import axios, { AxiosRequestConfig } from "axios";

import { FormType } from "../components/enums";
import {
  selectACFormData,
  selectOCVehicleFormData,
} from "../store/rootSelectors";

import { ApiError } from "./error";

export async function postTextData(
  apiEndpoint: string,
  data:
    | ReturnType<typeof selectACFormData>
    | ReturnType<typeof selectOCVehicleFormData>,
  formType: FormType
): Promise<string> {
  const config: AxiosRequestConfig = {
    method: "POST",
    url: [apiEndpoint, formType].join("/"),
    headers: {
      "Content-Type": "application/json",
    },
    data,
    responseType: "json",
  };

  try {
    const {
      data: { FolderId: folderId },
    } = await axios(config);

    //JIRA LPPLWEBMOB-697
    localStorage.removeItem("DamageNumber");
    localStorage.setItem("DamageNumber", folderId);

    return folderId;
  } catch (error) {
    throw new ApiError(error.message);
  }
}
